import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { apiMessage } from '@/hooks/offers/api-message'
import { useAuth } from '@/hooks/useAuth'
import { userProfileService } from '@/services/user-profile.service'

/**
 * "Log out everywhere" (TO-197 REQ-009): confirmed first; on 204 the local
 * sign-out runs (this session ends too); on a refusal the user stays signed in
 * and sees why.
 */
export function useLogOutEverywhere() {
	const { logout } = useAuth()
	const [isConfirming, setConfirming] = useState(false)
	const mutation = useMutation({
		mutationFn: () => userProfileService.revokeSessions(),
		onSuccess: () => {
			setConfirming(false)
			logout()
		},
		onError: () => setConfirming(false),
	})
	return {
		isConfirming,
		isBusy: mutation.isPending,
		error: mutation.error ? (apiMessage(mutation.error) ?? null) : null,
		hasFailed: mutation.isError,
		request: () => {
			mutation.reset()
			setConfirming(true)
		},
		cancel: () => setConfirming(false),
		confirm: () => mutation.mutate(),
	}
}
